import clsx from "clsx";
import Demyst from "../assets/Demyst.svg";

export const Button = ({
  autoWidth = false,
  demystIcon = false,
  hidden,
  children,
  variant = "primary",
  size = "lg",
  disabled,
  onClick,
  className,
  ...props
}) => {
  return (
    <button
      onClick={e => onClick && onClick(e)}
      className={clsx(
        "button-component",
        variant === "inverted" && "button-component-inverted",
        variant === "secondary" && "button-component-secondary",
        hidden && "hidden",
        autoWidth && "button-component-autoWidth",
        size && `button-component-size-${size}`,
        className,
      )}
      disabled={disabled}
      {...props}
    >
      <span>{children}</span>
      {demystIcon && <img src={Demyst.src} alt="" width="16" height="22" loading="eager" />}
    </button>
  );
};
